import { render, staticRenderFns } from "./ColorPicerTemplate.vue?vue&type=template&id=2c9d1b31&"
import script from "./ColorPicerTemplate.vue?vue&type=script&lang=js&"
export * from "./ColorPicerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ColorPicerTemplate.vue?vue&type=style&index=0&id=2c9d1b31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports